// @flow
export const SimplePasswordInputVariables = {
  errorColor: '--rp-password-input-error-color',
  errorColorLight: '--rp-password-input-error-color-light',
  warningColor: '--rp-password-input-warning-color',
  warningColorLight: '--rp-password-input-warning-color-light',
  successColor: '--rp-password-input-success-color',
  successColorLight: '--rp-password-input-success-color-light',
};

const Vars = SimplePasswordInputVariables;

export const SimplePasswordInputDefaults = {
  [Vars.errorColor]: '#ea4c5b',
  [Vars.errorColorLight]: 'rgba(234, 76, 91, 0.4)',
  [Vars.warningColor]: '#f2a218',
  [Vars.warningColorLight]: 'rgba(242, 162, 24, 0.4)',
  [Vars.successColor]: '#2dc06c',
  [Vars.successColorLight]: 'rgba(45, 192, 108, 0.4)',
};
